export class FactoryInvoices {
  bookingOrderCode: string;
  bookingOrderId: string;
  checkPrerecordListDate: string;
  collectInvoiceDate: string;
  collectInvoiceState: string;
  declarationDescription: string;
  factoryInvoiceProducts: FactoryInvoiceProducts[];
  factoryInvoiceProductsName: string;
  factoryName: string;
  fcr: string;
  finalInvoiceAmount: number;
  id: string;
  invoiceUnit: string;
  seller: string;
  settlementQuantity: number;
  purchaseOrderNumber: string;
  deductions: Deductions;
  remark: string;
  isEditCollectionStatePopoverVisible: false;
  confirm: boolean;
  declarationAmount: number;
}
export class FactoryInvoiceProducts {
  adjustUnitPrice: number;
  claimCharge: number;
  deductionAndFilling: any;
  deductionAndFillingRemark: string;
  factoryInvoiceId: string;
  fcr: string;
  id: string;
  invoiceDescription: string;
  labelingCharge: number;
  otherCharge: number;
  purchaseOrderNumber: string;
  quantity: number;
  settlementUnit: string;
  totalAdjustAmount: any;
  totalDeclarationAmount: number;
  uploadUnitPrice: number;
  weight: number;
  selectUnit: SelectUnit[];
  totalSettlementAmount: number;
  totalUploadAmount: number;
  returnSettlementAmount: number;
  productType: string;
  purchaseOrderFee: number;
}
export class SelectUnit {
  value: string;
  label: string;
}
// 调整开票
export class LoadingAudit {
  bookingOrderCode: string;
  factoryInvoiceId: string;
  factoryInvoiceProducts: FactoryInvoiceProducts[];
  factoryName: string;
  seller: string;
  settledHqPackingListIds: string;
  totalDeclarationAmount: number;
  totalSettlementAmount: number;
  totalAdjustAmount: any;
  totalUploadAmount: number;
  deductionAndFilling: any;
  confirm: boolean;
  quantity: number;
}

export class Deductions{
  claimCharge: number
  deductionAndFilling: number
  deductionAndFillingRemark: string
  labelingCharge: number
  otherCharge: number
  totalDeductions: number
}
